import { render, staticRenderFns } from "./r-slider.vue?vue&type=template&id=0ed4c1d6"
import script from "./r-slider.vue?vue&type=script&lang=js"
export * from "./r-slider.vue?vue&type=script&lang=js"
import style0 from "./r-slider.vue?vue&type=style&index=0&id=0ed4c1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports